import axios from 'axios';
import {req, getByobj, exportExcel, postobj} from './axiosFun';
/**
 * 资产明细管理
 **/
//团长详情查询
export const leaderById = (params) => { return req("get","/leader/"+params) };
// 团长资产明细查询
export const assetList = (params) => { return getByobj("get", "/leader/assetDetails", params) };
//团长离职
export const leaveLeader = (params) => { return postobj("post", "/leader/depart",params) };
//国大门店列表
export const getStore = (params) => { return getByobj("get", "/leader/getStore",params) };
//团长换店、3升2、2降3
export const leaderChange = (params) => { return postobj("post", "/leader/leaderChange",params) };
//团长资产明细导出
export const detailsExport = (params) => { return exportExcel("get", "/leader/detailsExport",params) };



// WEBPACK FOOTER //
// ./src/api/leader.js